<template>
  <div>
    <div
      v-for="langChoice in availableLanguages"
      :key="langChoice.code"
      @click.prevent="() => (lang = langChoice.code)"
    >
      <span :class="{ active: lang === langChoice.code }">
        {{ langChoice.name }}
      </span>
    </div>
  </div>
</template>

<script>
  import mixins from '@/mixins';

  export default {
    name: 'LocalizationPickerWidget',
    mixins: [mixins.LocalizationMixin],

    props: {
      doric: {
        inputs: {
          label: 'Localization',
        },
      },
    },
  };
</script>

<style scoped lang="scss">
  span {
    cursor: pointer;
    &.active {
      font-weight: bold;
    }
  }
</style>
